import { render, staticRenderFns } from "./MCheckbox.vue?vue&type=template&id=99d20846"
import script from "./MCheckbox.vue?vue&type=script&lang=js"
export * from "./MCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MCheckbox.vue?vue&type=style&index=0&id=99d20846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports